import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import moment from 'moment';

export default createReactClass({
  displayName: 'Root',
  PropTypes: {
    event: PropTypes.object.isRequired,
    hasUnreadMessage: PropTypes.bool.isRequired,
    currentEventId: PropTypes.integer,
    isCompany: PropTypes.bool,
    isLast: PropTypes.bool,
    unreadMessageCount: PropTypes.integer,
    lastMessage: PropTypes.object.isRequired,
  },
  getInitialState() {
    return {
      event: this.props.event,
    };
  },
  onError() {
    var updated = this.state.event;
    updated.main_image_url_thumb = '/images/ja2/img_noimage.gif';
    this.setState({
      event: updated,
    });
  },
  render() {
    var lastMessageFormatted = '';
    if (this.props.lastMessage) {
      var now = moment();
      var createdDay = moment(this.props.lastMessage.created_at);
      if (now.isSame(createdDay, 'days')) {
        lastMessageFormatted = createdDay.format('HH:mm');
      } else {
        lastMessageFormatted = createdDay.format('MM/DD');
      }
    }
    var circleName = this.props.event.circle
      ? this.props.event.circle.name
      : '';
    var isSelected = '';
    // var hasUnreadMessage = this.props.hasUnreadMessage;
    var unreadMessageCount =
      this.props.unreadMessageCount > 0 ? (
        <p className="badge--unread unread--message">
          {this.props.unreadMessageCount}
        </p>
      ) : (
        ''
      );
    // var unreadBadge;
    if (this.props.currentEventId == this.state.event.id) {
      isSelected = 'is-selected';
    } else {
      isSelected = '';
    }
    let messageRoomUri = this.props.isCompany
      ? '/companies/companies_messages/event/' + this.state.event.id
      : this.props.companyId
        ? '/community/' +
          this.props.companyId +
          '/message/event/' +
          this.state.event.id
        : '/message/event/' + this.state.event.id;
    // unreadBadge = hasUnreadMessage ? (
    //   <div style={{ display: "flex" }}>
    //     <span
    //       className="badge g-color-white g-bg-red "
    //       style={{ fontSize: "8px" }}
    //     >
    //       未読
    //     </span>
    //   </div>
    // ) : (
    //   ""
    // );
    // return <a href={messageRoomUri} className={'block-member ' + isSelected} style={{display:'flex', flexDirection:'row', alignItems:'center' }}>
    //     <div style={{display:'flex', alignItems:'center'}}>
    //         <div className="icon-type1">
    //             <img src={this.state.event.main_image_url_thumb} onError={this.onError}/>
    //         </div>
    //         <span className="txt-member">
    //             {this.state.event.event_date ? moment(this.state.event.event_date).format('MM/DD') : ''} {this.state.event.title}
    //         </span>
    //         {unreadBadge}
    //     </div>
    // </a>;
    return (
      <li>
        <a href={messageRoomUri} className={'hov--default ' + isSelected}>
          <div
            className={`row justify-content-around align-items-center pt-3 pb-3 ${
              this.props.isLast ? '' : 'border-bottom'
            }`}
          >
            <div className="col-2 pr-1">
              <img
                className="lazyload rounded-circle member-icon_48px"
                data-src={this.state.event.main_image_url_thumb}
                onError={this.onError}
              />
            </div>
            <div className="col-8 pl-3 pr-2">
              <p
                className="mb-1 line-1 position-relative mr-4"
                style={{ overflow: 'scroll' }}
              >
                <span
                  className="badge badge-light"
                  style={{
                    fontWeight: this.props.unreadMessageCount > 0 ? 700 : 400,
                  }}
                >
                  {circleName}
                </span>
              </p>
              <p
                className="mb-1 line-1 position-relative pr-4"
                style={{
                  fontWeight: this.props.unreadMessageCount > 0 ? 700 : 400,
                }}
              >
                {this.state.event.event_date
                  ? moment(this.state.event.event_date).format('MM/DD')
                  : ''}{' '}
                {this.state.event.title}
                <span className="position-absolute position--messagenum">
                  ({this.state.event.num_of_participants})
                </span>
              </p>
              <p className="text-fz-14px text-black-20 mb-0 line-2">
                {this.props.lastMessage ? this.props.lastMessage.body : ''}
              </p>
            </div>
            <div className="col-2 p-0 align-self-start">
              <p className="text-fz-small text-black-20 mb-0 text-center">
                {lastMessageFormatted}
              </p>
              {unreadMessageCount}
            </div>
          </div>
        </a>
      </li>
    );
  },
});
